var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('sui-container',{staticClass:"training-resource-container"},[_c('div',{staticClass:"side-menu"},[_c('Menu',{attrs:{"resource-items":_vm.sideMenuItems}})],1),_c('div',{staticClass:"resource-list"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }